const reservationMixins = {
  methods: {
    reservationStatus(status) {
      switch (status) {
        case 'checked-in':
          return 'arrow_forward';
        case 'checked-out':
          return 'arrow_back';
        case 'booked':
          return 'calendar_today';
        default:
          return 'error';
      }
    },
    reservationColor(status) {
      switch (status) {
        case 'checked-in':
          return 'green';
        case 'checked-out':
          return 'red';
        case 'booked':
          return 'blue';
        default:
          return 'yellow';
      }
    },
    reservationText(status) {
      switch (status) {
        case 'checked-in':
          return 'est entré dans';
        case 'checked-out':
          return 'a quitté';
        case 'booked':
          return 'a réservé';
        default:
          return '[status inconnu]';
      }
    },
  },
};

const filtersCaseMixins = {
  filters: {
    upperCaseFirst(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};

export {
  reservationMixins,
  filtersCaseMixins,
};
